import React from 'react';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ComparisonIcon from '@mui/icons-material/AccessTime';
import DistributionIcon from '@mui/icons-material/BubbleChart';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import ImportantDevicesIcon from '@mui/icons-material/ImportantDevices';
import SettingsSystemDaydreamIcon from '@mui/icons-material/SettingsSystemDaydream';
import MonitorHeartIcon from '@mui/icons-material/MonitorHeart';
import BarChartIcon from '@mui/icons-material/BarChart';
import MessageIcon from '@mui/icons-material/Email';
import SecurityIcon from '@mui/icons-material/Security';
import TransactionIcon from '@mui/icons-material/LocalAtm';
import ReportIcon from '@mui/icons-material/Assignment';
import OperationIcon from '@mui/icons-material/Receipt';
import DeveloperBoardIcon from '@mui/icons-material/DeveloperBoard';
import SettingsIcon from '@mui/icons-material/Settings';
import Collapse from '@mui/material/Collapse';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Drawer from '@mui/material/Drawer';
import { I18n } from 'aws-amplify/utils';
import {AccountType, UserType} from "../../../Models/Enums";
import './Drawer.css';
import {UserRoles} from "../../../Models/Roles";
import {AssignmentTurnedIn, WorkspacePremium , History} from "@mui/icons-material";
import { DashboardPage } from "../../../Models/DashboardPages";

const Restricted = {
	ADMIN:"ADMIN",
	ACTIVATIONS:"ACTIVATIONS",
	HARDWARES:"HARDWARES",
	LICENSES:"LICENSES"
}

/**
 * Affiche la navigation latérale selon les droits de l'utilisateur et la page active.
 * @param {object} props
 * @param {boolean} props.opened
 * @param {boolean} props.isDesktop
 * @param {boolean} [props.isIOS] Passed by AppBar; currently unused.
 * @param {{id: number, type: number, accountType: number, role: number} | null} props.currentUser
 * @param {number} props.selectedIndex DashboardPage value for the selected screen.
 * @param {(opened: boolean) => void} props.handleDrawer
 * @param {(event: React.MouseEvent, page: number) => void} props.handleListItemClick
 * @param {object} [props.observer] Passed by AppBar; currently unused.
 */
export default function CmDrawer( props ) {
	const [expanded, setExpanded] = React.useState(true);
	const [expandedTech, setExpandedTech] = React.useState(false);
	const [expandedLicense, setExpandedLicense] = React.useState(true);
	const handleNestedListClick = () => {
		setExpanded( ! expanded ); 
	};
	
	const handleTechNestedListClick = () => {
		setExpandedTech( ! expandedTech ); 
	};

	const handleLicenseNestedListClick = () => {
		setExpandedLicense( ! expandedLicense );
	};
	
	/** @param {string} menu */
	const renderRestrictedAccess =  menu  => {
		const UNRESTRICTED_USERS = [ 1 , 401 ];
		switch( menu ) {
			case Restricted.ADMIN:
				//if( props?.observer?.payStations?.length < 1 ) return null;

				if( props.currentUser ) {
					if( ( props.currentUser.type === UserType.ROOT || props.currentUser.type === UserType.ADMIN ) &&
						props.isDesktop &&
						props.currentUser.role !== UserRoles.SALE_ROLE &&
						props.currentUser.role !== UserRoles.ADMINISTRATIVE ) {
						return (
							<ListItemButton selected={props.selectedIndex === DashboardPage.ADMINISTRATION}
									  		onClick={(event) => props.handleListItemClick(event, 13)}>
								<ListItemIcon>
									<SecurityIcon />
								</ListItemIcon>
								<ListItemText primary={I18n.get("Administration")} />
							</ListItemButton>
						);
					}
				}
			break;
			case Restricted.ACTIVATIONS:
				//return null;
				if( props.currentUser ) {
					if( ( props.currentUser.accountType === AccountType.ADMIN ||
						props.currentUser.accountType === AccountType.SUPPORT ||
						props.currentUser.accountType === AccountType.RESELLER ||
						props.currentUser.type === UserType.ROOT ) &&
						props.isDesktop &&
						props.currentUser.role !== UserRoles.SALE_ROLE &&
						props.currentUser.role !== UserRoles.ADMINISTRATIVE ) {
						return (
							<ListItemButton selected={props.selectedIndex === DashboardPage.ACTIVATIONS}
											onClick={(event) => props.handleListItemClick(event, DashboardPage.ACTIVATIONS)}>
								<ListItemIcon>
									<ImportantDevicesIcon />
								</ListItemIcon>
								<ListItemText primary={I18n.get("Activations")} />
							</ListItemButton>
						);
					}
				}
			break;
			case Restricted.HARDWARES:
				//return null;
				if( props.currentUser ) {
					if( ( props.currentUser.accountType === AccountType.ADMIN ||
						props.currentUser.accountType === AccountType.SUPPORT ||
						props.currentUser.accountType === AccountType.RESELLER ||
						props.currentUser.type === UserType.ROOT ) &&
						props.isDesktop &&
						props.currentUser.role !== UserRoles.ADMINISTRATIVE) {
						return (
							<React.Fragment>
								<ListItemButton
									onClick={handleTechNestedListClick}>
									<ListItemIcon>
										<SettingsSystemDaydreamIcon />
									</ListItemIcon>
									<ListItemText primary={I18n.get("Hardwares")} />
									{expandedTech ? <ExpandLess /> : <ExpandMore />}
								</ListItemButton>
								<Collapse in={expandedTech} timeout="auto" unmountOnExit>
									<List component="div" disablePadding className="subList">
										{renderMonitoring()}
										{renderOverview()}
										<ListItemButton selected={props.selectedIndex === DashboardPage.DIAGNOSTIC}
														onClick={(event) => props.handleListItemClick(event, DashboardPage.DIAGNOSTIC)}>
											<ListItemIcon>
												<SettingsIcon />
											</ListItemIcon>
											<ListItemText primary={I18n.get("Diagnostic")} />
										</ListItemButton>
										<ListItemButton selected={props.selectedIndex === DashboardPage.HARDWARE_HISTORY}
														onClick={(event) => props.handleListItemClick(event, DashboardPage.HARDWARE_HISTORY)}>
											<ListItemIcon>
												<History />
											</ListItemIcon>
											<ListItemText primary={I18n.get("History")} />
										</ListItemButton>
									</List>
								</Collapse>
							</React.Fragment>
						);
					}
				}

			break;
			case Restricted.LICENSES:
				if( props.currentUser ) {
					if( props.isDesktop &&
						( props.currentUser.role === UserRoles.ADMINISTRATIVE ||
							UNRESTRICTED_USERS.includes(props.currentUser.id)  ) ) {
						return (
							<>
								<ListItemButton selected={props.selectedIndex === DashboardPage.LICENSES_ASSIGNMENT || props.selectedIndex === DashboardPage.LICENSES_HISTORY }
												onClick={handleLicenseNestedListClick}>
									<ListItemIcon>
										<WorkspacePremium />
									</ListItemIcon>
									<ListItemText primary={I18n.get("Licenses")} />
									{expandedLicense ? <ExpandLess /> : <ExpandMore />}
								</ListItemButton>
								<Collapse in={expandedLicense} timeout="auto" unmountOnExit>
									<List component="div" disablePadding className="subList">
										<ListItemButton selected={props.selectedIndex === DashboardPage.LICENSES_ASSIGNMENT}
														onClick={(event) => props.handleListItemClick(event, DashboardPage.LICENSES_ASSIGNMENT)}>
											<ListItemIcon>
												<AssignmentTurnedIn />
											</ListItemIcon>
											<ListItemText primary={I18n.get("Assignment")} />
										</ListItemButton>
										<ListItemButton selected={props.selectedIndex === DashboardPage.LICENSES_HISTORY}
														onClick={(event) => props.handleListItemClick(event, DashboardPage.LICENSES_HISTORY)}>
											<ListItemIcon>
												<History />
											</ListItemIcon>
											<ListItemText primary={I18n.get("History")} />
										</ListItemButton>
									</List>
								</Collapse>
							</>
						);
					}
				}

				break;
			default:
			break;
		}
		
		return null;
	}

	const renderOverview = () => {
		if( props?.currentUser?.role !== UserRoles.SALE_ROLE ) {
			return (
				<ListItemButton selected={props.selectedIndex === DashboardPage.OVERVIEW}
								onClick={(event) => props.handleListItemClick(event, DashboardPage.OVERVIEW)}>
					<ListItemIcon>
						<DeveloperBoardIcon />
					</ListItemIcon>
					<ListItemText primary={I18n.get("Overview")} />
				</ListItemButton>
			);
		}
		return null;
	}

	const renderReports = () => {
		if( props?.currentUser?.role === UserRoles.ADMINISTRATIVE ) {
			return null;
		}

		return (
			<>
				<ListItemButton selected={props.selectedIndex === DashboardPage.REPORTS}
								onClick={handleNestedListClick}>
					<ListItemIcon>
						<ReportIcon />
					</ListItemIcon>
					<ListItemText primary={I18n.get("Reports")} />
					{expanded ? <ExpandLess /> : <ExpandMore />}
				</ListItemButton>
				<Collapse in={expanded} timeout="auto" unmountOnExit>
					<List component="div" disablePadding className="subList">
						<ListItemButton selected={props.selectedIndex === DashboardPage.OPERATIONS}
										onClick={(event) => props.handleListItemClick(event, DashboardPage.OPERATIONS)}
										className={nested}>
							<ListItemIcon>
								<OperationIcon />
							</ListItemIcon>
							<ListItemText primary={I18n.get("Operations")} disableTypography={true}/>
						</ListItemButton>
						<ListItemButton selected={props.selectedIndex === DashboardPage.CASH_IN}
										onClick={(event) => props.handleListItemClick(event, DashboardPage.CASH_IN)}
										className={nested}>
							<ListItemIcon>
								<TransactionIcon />
							</ListItemIcon>
							<ListItemText primary={I18n.get("Cash in")} disableTypography={true}/>
						</ListItemButton>
						<ListItemButton selected={props.selectedIndex === DashboardPage.INVENTORIES}
										onClick={(event) => props.handleListItemClick(event, DashboardPage.INVENTORIES)}
										className={nested}>
							<ListItemIcon>
								<BarChartIcon />
							</ListItemIcon>
							<ListItemText primary={I18n.get("Inventories")} disableTypography={true}/>
						</ListItemButton>
						<ListItemButton selected={props.selectedIndex === DashboardPage.DISTRIBUTIONS}
										onClick={(event) => props.handleListItemClick(event, DashboardPage.DISTRIBUTIONS)}
										className={nested}>
							<ListItemIcon>
								<DistributionIcon />
							</ListItemIcon>
							<ListItemText primary={I18n.get("Distributions")} disableTypography={true} />
						</ListItemButton>
						<ListItemButton selected={props.selectedIndex === DashboardPage.COMPARISONS}
										onClick={(event) => props.handleListItemClick(event, DashboardPage.COMPARISONS)}
										className={nested}>
							<ListItemIcon>
								<ComparisonIcon />
							</ListItemIcon>
							<ListItemText primary={I18n.get("Comparisons")} disableTypography={true}/>
						</ListItemButton>
						{/*<ListItem button
										  selected={props.selectedIndex === DashboardPage.CASHIERS}
										  onClick={(event) => props.handleListItemClick(event, DashboardPage.CASHIERS)}
										  className={nested}>
									<ListItemIcon>
										<CashierIcon />
									</ListItemIcon>
									<ListItemText primary={I18n.get("Cashiers")} />
								</ListItem>*/}
						{/*<ListItemButton selected={props.selectedIndex === DashboardPage.FORECASTS}
												onClick={(event) => props.handleListItemClick(event, DashboardPage.FORECASTS)}
												className={nested}>
									<ListItemIcon>
										<InsightsIcon />
									</ListItemIcon>
									<ListItemText primary={I18n.get("Forecasts")} disableTypography={true}/>
								</ListItemButton>*/}
						<ListItemButton selected={props.selectedIndex === DashboardPage.MESSAGES}
										onClick={(event) => props.handleListItemClick(event, DashboardPage.MESSAGES)}
										className={nested}>
							<ListItemIcon>
								<MessageIcon />
							</ListItemIcon>
							<ListItemText primary={I18n.get("Messages")} disableTypography={true}/>
						</ListItemButton>
					</List>
				</Collapse>
			</>
		);
	}

	const renderHome = () => {
		return null;
		/*if( props?.currentUser?.role === UserRoles.ADMINISTRATIVE ) {
			return null;
		}
		return (
			<ListItemButton selected={props.selectedIndex === DashboardPage.DASHBOARD}
							onClick={(event) => props.handleListItemClick(event, DashboardPage.DASHBOARD)}>
				<ListItemIcon>
					<DashboardIcon />
				</ListItemIcon>
				<ListItemText primary={I18n.get("Dashboard")} />
			</ListItemButton>
		);*/
	}

	const renderMonitoring = () => {
		if( props?.currentUser?.role === UserRoles.ADMINISTRATIVE ) {
			return null;
		}
		return (
			<ListItemButton selected={props.selectedIndex === DashboardPage.MONITORING}
							onClick={(event) => props.handleListItemClick(event, DashboardPage.MONITORING)}>
				<ListItemIcon>
					<MonitorHeartIcon />
				</ListItemIcon>
				<ListItemText primary={I18n.get("Monitoring")} />
			</ListItemButton>
		);
	}

	const nested = "";
	const sharedStyle = ( props.isDesktop ) ? 'drawer-paper desktop' : 'drawer-paper';
	return (
		<Drawer variant="permanent"
				open={props.opened}
				className={`${ (props.opened) ? sharedStyle : sharedStyle + ' close' }`}
				classes={{
					paper: `${(props.opened)? sharedStyle : sharedStyle + ' close'}`
				}}>
			<div className="toolbarIcon">
				<IconButton onClick={ event => props.handleDrawer(false)}>
					<ChevronLeftIcon />
				</IconButton>
			</div>
			<Divider />
			<List>
				{renderHome()}
				{renderReports()}
				{/*<ListItemButton selected={props.selectedIndex === DashboardPage.MAP}
								onClick={(event) => props.handleListItemClick(event, DashboardPage.MAP)}>
					<ListItemIcon>
						<MapIcon />
					</ListItemIcon>
					<ListItemText primary={I18n.get("Map")} />
				</ListItemButton>*/}
				{renderRestrictedAccess( Restricted.ACTIVATIONS )}
				{renderRestrictedAccess( Restricted.HARDWARES )}
				{renderRestrictedAccess( Restricted.ADMIN )}
				{renderRestrictedAccess( Restricted.LICENSES )}
				{/*<ListItemButton
						  selected={props.selectedIndex === DashboardPage.ENVIRONMENT}
						  onClick={(event) => props.handleListItemClick(event, DashboardPage.ENVIRONMENT)}>
					<ListItemIcon>
						<ImportantDevicesIcon />
					</ListItemIcon>
					<ListItemText primary={I18n.get("Environment")} />
				</ListItemButton>*/}
			</List>
		</Drawer>
	);
}
